const TEMPLATE_WITH_GRID_MATERIAL_FRAMEWORK = 'onair';
export default {
  data() {
    return {
      template: template,
    };
  },
  methods: {
    calculateColumns() {
      if (this.template == TEMPLATE_WITH_GRID_MATERIAL_FRAMEWORK) {
        return this.gridMaterial();
      } else {
        return this.gridBootstrap();
      }
    },
    gridBootstrap() {
      return 'col-md my-auto';
    },
    gridMaterial() {
      return `col ${this.cols}`;
    }
  }
}